export default class NavSticky {
  constructor(el) {
    this.root = el;
    this.sentinel = null;
    this.observer = null;

    this.init();
    this.bindResize();
  }

  init() {
    if (this.sentinel) this.sentinel.remove();
    if (this.observer) this.observer.disconnect();

    this.sentinel = document.createElement("div");
    Object.assign(this.sentinel.style, {
      position: "absolute",
      top: `${window.innerHeight * 0.8}px`,
      left: "0",
      width: "1px",
      height: "1px",
      pointerEvents: "none",
      visibility: "hidden",
    });
    document.body.appendChild(this.sentinel);

    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      const wasStuck = this.root.classList.contains("is-stuck");
      this.root.classList.toggle("is-stuck", past);
      if (wasStuck && !past) {
        document.dispatchEvent(new CustomEvent("nav-sticky:unstuck"));
      }
    });

    this.observer.observe(this.sentinel);
  }

  bindResize() {
    let timer;
    window.addEventListener("resize", () => {
      clearTimeout(timer);
      timer = setTimeout(() => this.init(), 150);
    });
  }
}
